export let MessageDirection = /*#__PURE__*/ function (MessageDirection) {
    MessageDirection["Incoming"] = "incoming";
    MessageDirection["Outgoing"] = "outgoing";
    return MessageDirection;
}({});
